<template>
  <div id="divSummary">
    <div class="Flex_Table tblEntryForm">
      <div class="Flex_Row">
        <div class="Flex_Cell" width="30%">
          <div class="Flex_Table tblEntryForm">
            <div class="Flex_Row">
              <div class="Flex_Cell">
                <span class="mandatorySpan">Ticket / Ref. Number :</span>
                <!-- <AcceptInput
                  :isRequired="true"
                  placeholder="Ticket / Ref. Number"
                  ref="txtTicketNo"
                  v-model="TicketNo"
                  maxlength="256"
                  title="Enter Ticket Number."
                  width="300px"
                  @input="PrintTicket()"
                /> -->
                <input
                  type="text"
                  placeholder="Ticket / Ref. Number"
                  ref="txtTicketNo"
                  v-model="TicketNo"
                  maxlength="256"
                  title="Enter Ticket Number."
                  width="300px"
                  @input="PrintTicketTemp()"
                />
              </div>
            </div>
            <div class="Flex_Row">
              <div class="Flex_Cell" width="60%" align="left">
                <span>{{ this.scancount }}</span>
              </div>
              <div class="Flex_Cell" width="20%" align="middle">
                <input
                  type="button"
                  title="Click to SaveProfile"
                  value="Get"
                  v-on:click="PrintTicket()"
                />
              </div>
              <div class="Flex_Cell" width="20%" align="middle">
                <input
                  type="button"
                  title="Click to Reset"
                  value="Reset"
                  v-on:click="onResetClick()"
                />
              </div>
            </div>
          </div>
          <fieldset style="text-align: center; width: 98%">
            <legend>Scan Ticket</legend>
            <div class="Flex_Table tblEntryForm">
              <div class="Flex_Row">
                <div class="Flex_Cell" style="width: 100%">
                  <div class="camera">
                    <video id="video">Video stream not available.</video>
                  </div>
                  <br />
                  <div style="text-align: center; display: none">
                    <input type="Button" id="startbutton" value="Scan Ticket" />
                  </div>
                  <canvas id="canvas" style="display: none"></canvas>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="Flex_Cell" width="70%">
          <div
            width="90%"
            class="Flex_Table tblEntryForm"
            v-bind:class="
              lstPrintTicket.isPaymentDone != 1
                ? 'page RedBorder'
                : 'page GreenBorder'
            "
            v-if="IsShow"
          >
            <div class="Flex_Row" align="center">
              <div class="Flex_Cell">
                <button
                  v-on:click="showTicket()"
                  title="Click Here to Print"
                  style="padding: 10px"
                  type="button"
                >
                  <i class="glyphicons print"></i> PRINT
                </button>
              </div>
            </div>
            <div class="Flex_Row" align="center">
              <div class="Flex_Cell">
                <img src="../assets/images/logoa.png" class="imgHeight" />
              </div>
            </div>
            <!-- <div class="Flex_Row" align="center">
              <div class="Flex_Cell">
                <span style="color: #054889; font-size: 22px"
                  ><b>{{ this.lstPrintTicket.placeToVisit }}</b></span
                >
              </div>
            </div> -->
            <div class="Flex_Row" align="center">
              <div class="Flex_Cell" style="color: #054889">
                <span style="font-size: 18px"><b>Booking Ticket For :</b></span>
                <span style="font-size: 18px">{{
                  lstPrintTicket.placeToVisit
                }}</span>
              </div>
            </div>
            <div class="Flex_Row">
              <div
                class="Flex_Cell"
                valign="middle"
                style="width: 30%"
                align="center"
              >
                <div id="divQRCodeData">
                  <img
                    id="imgQRCode"
                    style="width: 210px; height: 210px"
                    :src="'data:image/jpeg;base64,' + lstPrintTicket.qrCode"
                  />
                </div>
              </div>
              <div class="Flex_Cell" style="width: 70%">
                <div class="Flex_Table" style="padding-top: 20px">
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%"><b>Booking Type</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.bookingTypeName }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%"><b>Ticket No.</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.ticketNo }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%">
                      <b>Reference No.</b>
                    </div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.refNo }}
                    </div>
                  </div>
                  <div
                    class="Flex_Row tblRow"
                    v-if="this.lstPrintTicket.slotDetails != ''"
                  >
                    <div class="Flex_Cell" width="45%"><b>Slot Details</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.slotDetails }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%"><b>Booking Date</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.bookingdates }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%">
                      <span v-if="this.lstPrintTicket.isForGroup == 1">
                        <b>No. Of Groups</b></span
                      >
                      <span v-else> <b>No. Of Individuals</b></span>
                    </div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.totalNoOfIndividuals }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%"><b>Amount</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      Rs. <span>{{ this.lstPrintTicket.amount }}</span>
                    </div>
                  </div>
                  <div class="Flex_Row tblRow" v-if="lstPrintTicket.cgst > 0">
                    <div class="Flex_Cell" width="45%"><b>CGST</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.cgst }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow" v-if="lstPrintTicket.sgst > 0">
                    <div class="Flex_Cell" width="45%"><b>SGST</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.sgst }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow" v-if="lstPrintTicket.sgst > 0">
                    <div class="Flex_Cell" width="45%"><b>Other Tax</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.otherTax }}
                    </div>
                  </div>
                  <div
                    class="Flex_Row tblRow"
                    v-if="lstPrintTicket.discountAmount > 0"
                  >
                    <div class="Flex_Cell" width="45%">
                      <b>Discount Amount</b>
                    </div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.discountAmount }}
                    </div>
                  </div>
                  <div
                    class="Flex_Row tblRow"
                    v-if="lstPrintTicket.discountAmount > 0"
                  >
                    <div class="Flex_Cell" width="45%"><b>Promo Code</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      {{ this.lstPrintTicket.promoCode }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%"><b>Total Amount</b></div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      Rs. {{ this.lstPrintTicket.totalAmount }}
                    </div>
                  </div>
                  <div class="Flex_Row tblRow">
                    <div class="Flex_Cell" width="45%">
                      <b>Payment Status</b>
                    </div>
                    <div class="Flex_Cell" width="10%"><b>:</b></div>
                    <div class="Flex_Cell" width="45%">
                      <span
                        v-if="this.lstPrintTicket.isPaymentDone != 1"
                        style="color: RED; font-weight: bold"
                        >{{ this.lstPrintTicket.paymentStatus }}</span
                      >
                      <span
                        v-if="this.lstPrintTicket.isPaymentDone == 1"
                        style="color: GREEN; font-weight: bold"
                        >{{ this.lstPrintTicket.paymentStatus }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="Flex_Row tblRow"
              style="padding-top: 10px"
              v-if="lstPrintTicketReceipt.length > 0"
            >
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                <b>Payment Mode :</b>
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                {{ this.lstPrintTicketReceipt[0].paymentMode }}
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                <b>Transaction Id :</b>
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                {{ this.lstPrintTicketReceipt[0].transactionID }}
              </div>
            </div>
            <div
              class="Flex_Row tblRow"
              v-if="this.lstPrintTicketReceipt.length > 0"
            >
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                <b>Transaction Date :</b>
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                {{ this.lstPrintTicketReceipt[0].transCompleteDate }}
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                <b>Transaction Amount :</b>
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                Rs. {{ this.lstPrintTicketReceipt[0].paymentAmount }}
              </div>
            </div>
            <div
              class="Flex_Row tblRow"
              v-if="lstPrintTicketReceipt.length > 0"
            >
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                <b>Receipt No. :</b>
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%">
                {{ this.lstPrintTicketReceipt[0].receiptNo }}
              </div>
              <div class="Flex_Cell" valign="middle" style="width: 25%"></div>
              <div class="Flex_Cell" valign="middle" style="width: 25%"></div>
            </div>
            <div
              class="Flex_Row wrap"
              style="padding: 10px"
              v-if="lstPrintTicketReceipt.length > 0"
            >
              <b>Note </b> : &nbsp;
              <li>
                This receipt does not include any charges towards online
                transaction / convenience fee levied by payment gateway.
              </li>
            </div>
            <div class="Flex_Row" style="padding: 10px">
              <div class="Flex_Table ekkGrid" style="border-radius: 6px">
                <div
                  class="Flex_Row GridHeader"
                  valign="middle"
                  style="min-height: 40px"
                >
                  <div class="Flex_Cell" style="width: 25%">Category</div>
                  <div class="Flex_Cell" style="width: 25%">
                    No. of Person(s)
                  </div>
                  <div class="Flex_Cell" style="width: 25%">Rate</div>
                  <div class="Flex_Cell" style="width: 25%">
                    Amount (in Rs.)
                  </div>
                </div>
                <div
                  class="Flex_Row"
                  v-for="(row, index) in lstPrintTicket.printTicketDetails"
                  :key="index"
                  style="min-height: 30px"
                >
                  <div
                    class="Flex_Cell"
                    style="width: 25%"
                    valign="middle"
                    align="center"
                  >
                    {{ row.personAgeGroupName }}
                  </div>
                  <div
                    class="Flex_Cell"
                    style="width: 25%"
                    valign="middle"
                    align="center"
                  >
                    {{ row.totalNoOfPersons }}
                  </div>
                  <div
                    class="Flex_Cell"
                    style="width: 25%"
                    valign="middle"
                    align="center"
                  >
                    Rs. {{ row.individualRate }}
                  </div>
                  <div
                    class="Flex_Cell"
                    style="width: 25%"
                    valign="middle"
                    align="center"
                  >
                    Rs. {{ row.amountInRs }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="Flex_Row"
              style="padding: 10px"
              v-if="lstPrintTicket.printTicketVisitors"
            >
              <div class="Flex_Table ekkGrid" style="border-radius: 6px">
                <div
                  class="Flex_Row GridHeader"
                  valign="middle"
                  align="center"
                  style="min-height: 40px"
                >
                  <div class="Flex_Cell" style="width: 34%">Name</div>
                  <div class="Flex_Cell" style="width: 33%">Date of Birth</div>
                  <div class="Flex_Cell" style="width: 33%">Gender</div>
                  <!-- <div class="Flex_Cell" style="width: 20%">ID</div>
                  <div class="Flex_Cell" style="width: 20%">Contact Detail</div> -->
                </div>
                <div
                  class="Flex_Row"
                  v-for="(row, index) in lstPrintTicket.printTicketVisitors"
                  :key="index"
                  style="min-height: 30px"
                >
                  <div
                    class="Flex_Cell"
                    style="width: 34%"
                    valign="middle"
                    align="center"
                  >
                    {{ row.titleName }} {{ row.firstName }} {{ row.middleName }}
                    {{ row.lastName }}
                  </div>
                  <div
                    class="Flex_Cell"
                    style="width: 33%"
                    valign="middle"
                    align="center"
                  >
                    {{ row.dob }}
                  </div>
                  <div
                    class="Flex_Cell"
                    style="width: 33%"
                    valign="middle"
                    align="center"
                  >
                    {{ row.genderName }}
                  </div>
                  <!-- <div
                    class="Flex_Cell"
                    style="width: 20%"
                    valign="middle"
                    align="center"
                  >
                    <span>
                      {{ row.idTypeName }} <br />
                      {{ row.idNumber }}</span
                    >
                  </div>
                  <div
                    class="Flex_Cell"
                    style="width: 20%"
                    valign="middle"
                    align="center"
                  >
                    {{ row.email }}<br />{{ row.mobile }}
                  </div> -->
                </div>
              </div>
            </div>
            <div class="Flex_Row wrap" style="padding: 10px">
              <b>Note</b> : &nbsp;
              <li>
                BRO will not be liable for any kind of losses, damages or injury
                to anyone.
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <ModalPopup
      title="Ticket Print"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="ticketPrintDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      v-if="TicketNo != ''"
    >
      <div style="height: calc(100vh - 90px); width: 900px; overflow: auto">
        <PrintTicket :TicketNo="TicketNo" :eventBus="printbus"></PrintTicket>
      </div>
      <div style="text-align: center; background-color: whitesmoke">
        <input type="button" value="Print" v-on:click="printPDFReport()" />
      </div>
    </ModalPopup> -->
  </div>
</template>
<script>
import vue from "vue";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import Report from "@/router/Report";
import ModalPopup from "./ekkControls/ModalPopup";
import TicketJS from "./servicesJS/Ticket.js";
import MessageBox from "./ekkControls/MessageBox.vue";
export default {
  name: "StatusSummary",
  components: {
    AcceptInput: AcceptInput,
    DateControl: DateControl,
    ModalPopup: ModalPopup,
  },
  data() {
    return {
      TicketNo: "",
      lstPrintTicket: [],
      lstPrintTicketReceipt: [],
      IsShow: false,
      BookingID: -1,
      printbus: new vue(),
      ticketPrintDiv: false,
      scancount: "",
      noOfUnits: 0,

      width: 1280,
      height: 0,
      streaming: false,
      video: null,
      canvas: null,
      startbutton: null,
      autoScanTimer: null,
      showvideo: true,
      isSubmit: false,
    };
  },
  methods: {
    showTicket() {
      //alert('this.TicketNo : ' + this.TicketNo)
      const basicData = {
        FileName: "Ticket",
        FileFormat: "PDF",
        FileExtension: "pdf",
        Param1: "Ticket",
        Param2: "",
        BookingID: this.BookingID,
        TicketNo: this.TicketNo,
        type: 1,
      };
      var formData = new FormData();
      formData.append("BasicFormData", JSON.stringify(basicData));
      TicketJS.ShowPrintTicket(formData).then(
        (response) => {
          var msg = Report.showReport(response.data.result, false);
          if (msg == false) {
            MessageBox.show({
              message: "No Record Found",
              type: "error",
              title: "Error",
            });
          }
        },
        (error) => {}
      );
      // axios
      //   .get(config.WEB_API_PATH + "ScanTicket/ShowPrintTicket", {
      //     headers: {
      //       __RequestVerificationToken: config.AF_Token,
      //       Authorization: config.LOG_Token,
      //     },
      //     params: _data_,
      //     crossdomain: true,
      //   })
      //   .then(
      //     (response) => {
      //       if (response.data.length > 0) {
      //       } else {
      //         //this.ClearPrintTicket();
      //         alert("Not Found!");
      //       }
      //     },
      //     (error) => {}
      //   );
    },
    PrintTicket() {
      if (this.TicketNo == "") {
        MessageBox.show({
          message: "Enter Ticket No.",
          type: "error",
          title: "Error",
        });
        return;
      }
      if (this.TicketNo != "") {
        const _data_ = {
          BookingID: this.BookingID,
          TicketNo: this.TicketNo,
          FormID: 101,
          type: 1,
        };
        TicketJS.GetPrintTicket(_data_).then(
          (response) => {
            if (response.data.length > 0) {
              if (this.lstPrintTicket.bookingID != 0) {
                this.lstPrintTicket = response.data[0];
                this.IsShow = true;
                this.scancount =
                  this.lstPrintTicket.printTicketCount[0]["scanCount"];
                this.noOfUnits =
                  this.lstPrintTicket.printTicketDetails[0].noOfUnits;
                if (this.lstPrintTicket.printTicketReciept.length) {
                  this.lstPrintTicketReceipt =
                    this.lstPrintTicket.printTicketReciept;
                }
              }
            } else {
              MessageBox.show({
                message: "Ticket not found",
                type: "error",
                title: "Error",
              });
              this.ClearPrintTicket();
              return;
            }
          },
          (error) => {}
        );
      }
    },
    onResetClick() {
      this.TicketNo = "";
      this.ClearPrintTicket();
    },
    ClearPrintTicket() {
      this.lstPrintTicket = [];
      this.IsShow = false;
      //this.TicketNo = "";
      this.scancount = "";
      //imgQRCode.src = "";
    },
    onQRScannerClick() {
      let self = this;
      biometric.ekkScanQR(function (responce) {
        //console.log(responce);
        if (responce.data.IsVerified == "1") {
          var candID = responce.data.retString;
          this.BookingID = responce.data.retString;
          if (candID != "" && candID != -1) {
            self.getCandidateData(candID, 1);
            this.PrintTicket();
          }
        } else {
          MessageBox.show({
            message: responce.data.retString,
            type: "info",
            title: "Information",
          });
        }
      });
    },
    PrintTicketTemp() {
      if (this.TicketNo.length > 7) {
        this.PrintTicket();
      } else {
        this.ClearPrintTicket();
      }
    },
    // OpenPrintTicket()
    // {
    //    this.$router.push({ name: "PrintTicket" });
    //    //this.printbus.$emit("printPDF");
    // },
    printPDFReport() {
      this.printbus.$emit("printPDF");
    },
    modalPopupShown(e) {
      this.printPDFReport();
    },
    modalPopupClosed(e) {
      this.printbus = new vue();
      this.ClearPrintTicket();
    },
    printTicketForm() {
      let self = this;
      vue.nextTick(function () {
        self.printbus.$emit("PrintTicket");
        self.ticketPrintDiv = true;
      });
    },
    ShowLiveUpdate() {
      this.startWebCamera();
    },
    startWebCamera() {
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.webkitGetUserMedia;
      // if (
      //   !(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices)
      // )
      if (!navigator.getUserMedia) {
        MessageBox.show({
          message:
            "Browser not support web camera. Please update or provide proper setting for web camera.",
          type: "error",
          title: "Error",
        });
        return false;
      }
      this.video = document.getElementById("video");
      this.canvas = document.getElementById("canvas");
      this.startbutton = document.getElementById("startbutton");
      let me = this;
      // navigator.mediaDevices
      //   .getUserMedia({
      //     video: true,
      //     audio: false
      //   })
      //   .then(function(stream) {
      //     me.video.srcObject = stream;
      //     me.video.play();
      //   })
      //   .catch(function(err) {
      //     console.log("An error occurred: " + err);
      //   });
      navigator.getUserMedia(
        {
          video: { facingMode: "environment" },
          audio: false,
          height: 9999,
          width: 9999,
        },
        function (stream) {
          me.video.srcObject = stream;
          me.video.play();
        },
        function (err) {
          // console.log("An error occurred: " + err);
        }
      );

      this.video.oncanplay = function (ev) {
        if (!me.streaming) {
          me.height = me.video.videoHeight / (me.video.videoWidth / me.width);

          if (isNaN(me.height)) {
            me.height = width / (4 / 3);
          }

          me.video.setAttribute("width", 320);
          me.video.setAttribute("height", 320 / (4 / 3));
          me.canvas.setAttribute("width", me.width);
          me.canvas.setAttribute("height", me.height);
          me.streaming = true;
        }
      };

      this.startbutton.onclick = function (ev) {
        me.takepicture();
        if (me.showvideo) {
          //me.takepicture();
          //me.showvideo = false;
          //document.getElementById("dvCandPhotoCapture").style.display = "block";
          //document.getElementById("video").style.display = "none";
          //document.getElementById("startbutton").textContent =
          //("Capture Photo Again");
        } else {
          //me.showvideo = true;
          //document.getElementById("dvCandPhotoCapture").style.display = "none";
          //document.getElementById("video").style.display = "block";
          //document.getElementById("startbutton").textContent = "Capture Photo";
        }

        ev.preventDefault();
      };
      this.autoScanTimer = setInterval(function () {
        me.startbutton.click();
      }, 1000);
      this.clearphoto();
    },
    clearphoto() {
      var context = this.canvas.getContext("2d");
      context.fillStyle = "#AAA";
      context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    },
    takepicture() {
      var context = this.canvas.getContext("2d");
      let me = this;
      if (this.width && this.height) {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        context.drawImage(this.video, 0, 0, this.width, this.height);

        var data = this.canvas.toDataURL("image/jpeg");
        this.canvas.toBlob((blob) => {
          if (me.isSubmit) {
            return false;
          }
          me.isSubmit = true;
          var formData = new FormData();
          formData.append("file", blob, "LiveCapturePhoto.jpg");
          TicketJS.ReadQRCode(formData).then(
            (response) => {
              if (response.data.isSuccess) {
                FlashMessage.show(
                  "<span style='color:green'>" +
                    response.data.result +
                    "</span>",
                  1000
                );

                this.TicketNo = response.data.result;
                this.PrintTicket();
              }
              me.isSubmit = false;
              // Update the array forcefully
              //vue.set(me.candDocuments, rowIndex, docRow);
              //me.candDocuments.splice(rowIndex,1,docRow);
            },
            (error) => {
              if (error.response == undefined) {
                // console.log("Error:" + error);
                MessageBox.show({
                  message: error,
                  type: "error",
                  title: "Error",
                });
              } else {
                if (error.response.status == "415") {
                  // console.log("Error: " + error.response.statusText);
                  MessageBox.show({
                    message: error.response.statusText,
                    type: "error",
                    title: "Error",
                  });
                } else {
                  if (error.response.data.message == undefined) {
                    // console.log("Error: " + error.response.data);
                    MessageBox.show({
                      message: error.response.data,
                      type: "error",
                      title: "Error",
                    });
                  } else {
                    // console.log("Error: " + error.response.data.message);
                    MessageBox.show({
                      message: error.response.data.message,
                      type: "error",
                      title: "Error",
                    });
                  }
                }
              }
              me.isSubmit = false;
            },
            (failure) => {
              // console.log("Failure: " + failure);
              me.isSubmit = false;
            }
          );
        }, "image/jpeg");
      } else {
        this.clearphoto();
      }
    },
  },
  computed: {},
  mounted() {
    this.ShowLiveUpdate();
  },
  watch: {},
  beforeDestroy() {
    let me = this;
    if (
      me.video != null &&
      me.video.srcObject != undefined &&
      me.video.srcObject != null
    ) {
      me.video.srcObject.getTracks().forEach(function (track) {
        if (track.readyState == "live") {
          track.stop();
        }
      });
    }
    if (this.autoScanTimer != null) {
      clearInterval(this.autoScanTimer);
    }
  },
};
</script>
<style scoped>
.tblRow {
  border-bottom: solid 1px darkgray;
  padding-top: 3px;
  padding-bottom: 3px;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}

.RedBorder {
  padding: 10px;
  margin: 10px;
  border: solid 3px red;
}

.GreenBorder {
  padding: 10px;
  margin: 10px;
  border: solid 3px green;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.page {
  padding: 10px;
  margin: 10px;
  /* border: solid 1px black; */
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .imgHeight {
    width: 100px;
  }
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
  #video {
    border: 1px solid black;
    width: 320px;
    height: 240px;
  }

  #canvas {
    display: none;
  }

  .camera {
    width: 340px;
    display: inline-block;
  }

  .output {
    width: 340px;
    display: inline-block;
  }

  #startbutton {
    position: relative;
    padding: 5px;
    background-color: #6a67ce;
    border: 1px solid rgba(255, 255, 255, 0.7);
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
}
@media screen and (max-width: 480px) {
  .imgHeight {
    height: 55px;
  }
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScanTicket.vue